/** @format */

import React, { Component } from 'react';
import RequestPartOption from './RequestPartOption/RequestPartOption';

import { inject, observer } from 'mobx-react';

@inject('UserStore')
@inject('RequestsStore')
@observer
class RequestPartOptions extends Component {
  renderPartOptions = () => {
    const { RequestsStore, partId } = this.props;
    let options = RequestsStore.currentRequest.reqParts[partId].options;
    let renderPartOptions = null;
    if (options !== undefined && options !== null) {
      let optionsKeys = Object.keys(options);
      renderPartOptions = optionsKeys.map(optionKey => {
        return (
          <RequestPartOption
            key={optionKey}
            optionKey={optionKey}
            partId={partId}
          />
        );
      });
    }
    return renderPartOptions;
  };
  render() {
    return <div>{this.renderPartOptions()}</div>;
  }
}

export default RequestPartOptions;
